import type { TreeNode } from '@shared/ui-native/Tree';

const IFC_EXTENSION = '.ifc';

const getNodeName = (node: TreeNode): string => {
    const raw: string = node?.ajaxData?.name ?? node?.text ?? '';
    return typeof raw === 'string' ? raw : '';
};

export const isIfcModel = (node: TreeNode): boolean => {
    const name = getNodeName(node).toLowerCase();
    return name.endsWith(IFC_EXTENSION);
};
